/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UpdateSubmissionDto
 */
export interface UpdateSubmissionDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionDto
     */
    status?: UpdateSubmissionDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionDto
     */
    adminNotes?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateSubmissionDtoStatusEnum {
    Pending = 'Pending',
    Confirmed = 'Confirmed',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

